import React from 'react';
import { createRoot } from 'react-dom/client';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { GlobalContext, ToasterState } from './context';

import './assets/styles/global.scss';
import './assets/styles/common/app.scss';
import FilterState from './context/filterState';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <GlobalContext>
      <ToasterState>
        <FilterState>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <App />
          </MuiPickersUtilsProvider>
        </FilterState>
      </ToasterState>
    </GlobalContext>
  </BrowserRouter>
);
